import React, { useState } from 'react';
import TextField from '../../components/TextField';
import variables from '../../utils/variables';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, IconButton, InputAdornment } from '@mui/material';
import { config } from '../../config';
import { decodeFromBech32 } from '../../utils/address';
import { setDenomSplitInfo } from '../../actions/collection';
import './index.css';
import { showMessage } from '../../actions/snackbar';
import ClassName from 'classnames';

const SplitInfo = (props) => {
    const [duplicateAddress, setDuplicateAddress] = useState('');
    const [activeIndex, setActiveIndex] = useState(null);
    const [duplicateAddressState, setDuplicateAddressState] = useState(false);

    const handleAddressChange = (value, index) => {
        setDuplicateAddress('');
        setDuplicateAddressState(false);
        setActiveIndex(null);
        const duplicateAddresses = props.value.filter((item) => item.address === value);
        if (duplicateAddresses && duplicateAddresses.length) {
            setDuplicateAddressState(true);
            setDuplicateAddress(value);
            setActiveIndex(index);
        }
        const array = [...props.value];
        array[index].address = value;
        props.onChange([...array]);
    };

    const handlePercentageChange = (value, index) => {
        if (Number(value) > 100) {
            props.showMessage('Sum of all splits cannot exceed 100%');
            return;
        }
        const array = [...props.value];
        array[index].weight = value;
        let total = 0;
        array.map((val) => {
            total = Number(val.weight) + Number(total);

            return null;
        });

        if (total < 100 || total === 100) {
            props.onChange([...array]);
        } else {
            props.showMessage('Sum of all splits cannot exceed 100%');
        }
    };

    const handleCreate = () => {
        const array = [...props.value];
        array.push({
            address: '',
            weight: '',
        });
        props.onChange([...array]);
    };

    const handleRemove = (index) => {
        const array = [...props.value];
        const value = array.splice(index, 1);
        const duplicateAddresses = value && value[0] && value[0].address && props.value.filter((item) => item.address === value[0].address);
        if (duplicateAddresses && duplicateAddresses.length) {
            setDuplicateAddress('');
            setDuplicateAddressState(false);
            setActiveIndex(null);
        }
        props.onChange([...array]);
    };

    // const tokens = props.tokenPrice / 100;
    // let royalty = props.details && props.details.royalty_share;
    // royalty = royalty * 100;
    // let royaltyTokens = (props.tokenPrice - tokens) / 100;
    // royaltyTokens = royaltyTokens * royalty;
    let total = 0;

    return (
        <div className={ClassName('split_info_data', props.collectionDisable ? 'disabled' : '')}>
            {props.value && props.value.length
                ? props.value.map((val, index) => {
                    total = Number(val.weight) + total;
                    let valid = (val.address && decodeFromBech32(val.address) && (val.address.indexOf(config.PREFIX) > -1));
                    let disable = val.address === '' || val.weight === '' || total > 100 || total === 100 || !valid || duplicateAddressState;
                    // let percentageTokens = royaltyTokens
                    //     ? ((props.tokenPrice) - (tokens + royaltyTokens)) / 100
                    //     : (props.tokenPrice - tokens) / 100;
                    // percentageTokens = percentageTokens * val.weight;
                    // percentageTokens = percentageTokens && parseFloat(percentageTokens).toFixed(2);
                    if ((val.address === duplicateAddress) && (activeIndex === index)) {
                        valid = false;
                    }
                    if (val.address === props.address && props.value.length === 1) {
                        disable = false;
                    }
                    const errorText = !valid && duplicateAddressState && (activeIndex === index)
                        ? variables[props.lang]['this_address_added']
                        : !valid
                            ? variables[props.lang]['invalid_account_address'] : null;

                    return (
                        <>
                            <div key={index} className="row">
                                <TextField
                                    className={props.collectionDisable ? 'disabled_field drops_field' : 'drops_field'}
                                    disable={props.collectionDisable}
                                    error={(val.address !== '') ? !valid : false}
                                    errorText={errorText}
                                    helperText="Incorrect entry."
                                    id="address"
                                    name="address"
                                    placeholder={variables[props.lang]['enter_split_address']}
                                    value={val.address}
                                    onChange={(value) => handleAddressChange(value, index)}/>
                                <TextField
                                    className={props.collectionDisable ? 'disabled_field drops_field percentage' : 'drops_field percentage'}
                                    disable={props.collectionDisable}
                                    id="percentage"
                                    inputProps={{
                                        endAdornment: (
                                            <InputAdornment className="adornment" position="end">
                                                <span className="tokens"> % </span>
                                                {/* {props.tokenPrice && percentageTokens &&
                                                <span className="tokens"> % = {percentageTokens} </span>} */}
                                            </InputAdornment>
                                        ),
                                    }}
                                    name="percentage"
                                    // placeholder="The percentage should be split between 100%"
                                    placeholder={variables[props.lang]['enter_split_percentage']}
                                    type="number"
                                    value={val.weight}
                                    onChange={(value) => handlePercentageChange(value, index)}/>
                                {index === 0 && props.value.length === 1
                                    ? <IconButton className="remove_button hidden" disabled={props.collectionDisable}>-</IconButton>
                                    : <IconButton
                                        className="remove_button"
                                        disabled={props.collectionDisable}
                                        onClick={() => handleRemove(index)}>-</IconButton>}
                                {/* {total > 100 || total === 100 */}
                                {/*     ? <IconButton className="plus_button hidden">+</IconButton> */}
                                {/*     : props.value.length === (index + 1) */}
                                {/*         ? <IconButton */}
                                {/*             className="plus_button" disabled={disable} */}
                                {/*             onClick={handleCreate}>+</IconButton> */}
                                {/*         : <IconButton */}
                                {/*             className="remove_button" */}
                                {/*             onClick={() => handleRemove(index)}>-</IconButton>} */}
                            </div>
                            {props.value.length === (index + 1)
                                ? <div className="add_account_section">
                                    <Button className="add_account" disabled={disable || props.collectionDisable} onClick={handleCreate}>
                                        Add account +
                                    </Button>
                                </div>
                                : null}
                        </>
                    );
                }) : <div className="add_account_section">
                    <Button className="add_account" disabled={props.collectionDisable} onClick={handleCreate}>
                        Add account +
                    </Button>
                </div>}
        </div>
    );
};

SplitInfo.propTypes = {
    address: PropTypes.string.isRequired,
    details: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    showMessage: PropTypes.func.isRequired,
    tokenPrice: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    collectionDisable: PropTypes.bool,
};

const stateToProps = (state) => {
    return {
        address: state.account.connection.address,
        details: state.createAssets.listing.dialog.value,
        lang: state.language,
        value: state.collection.denomSplitInfo.value,
        tokenPrice: state.createAssets.nft.tokenPrice,
    };
};

const actionsToProps = {
    onChange: setDenomSplitInfo,
    showMessage,
};

export default connect(stateToProps, actionsToProps)(SplitInfo);
